module.exports = __webpack_public_path__ + "static/media/img_item_07.e81c40e0.png";